// Archivo para traducciones

import es from './es.json'
import en from './en.json'
import it from './it.json'
import pt from './pt.json'

//export const defaultLocale = 'es';

export const languages = {
	es: es,
	en: en,
	pt: pt,
	it: it
}
